import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import config from 'config';
import { reset, verifyToken } from '../../services/user/api';
import { handleChange } from '../../utils/ComponentUtilFunctions';
import { Link } from 'react-router-dom';
import BlueButton from '../../components-new/buttons/BlueButton';

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: false,
            password: '',
            confirmPassword: '',
            error: {
                password: '',
                confirmPassword: '',
            },
        };
        this.handleChange = handleChange.bind(this);
    }

    componentDidMount() {
        const { match, addNotification } = this.props;
        const { params } = match;
        const { token } = params;

        verifyToken(token)
            .then(() => {
                addNotification('yourTokenIsValid', config.notificationLevels.success);
            })
            .catch(() => {
                addNotification('yourTokenIsInvalid', config.notificationLevels.error, {
                    autoDismiss: 0,
                });
                setTimeout(() => {
                    window.location.href = '/login';
                }, 500);
            });
    }

    validatePassword = (value) => {
        if (value.length < 8) {
            return 'Password must be at least 8 characters long.';
        }
        if (!/[A-Z]/.test(value)) {
            return 'Password must contain at least one uppercase letter.';
        }
        if (!/[a-z]/.test(value)) {
            return 'Password must contain at least one lowercase letter.';
        }
        if (!/\d/.test(value)) {
            return 'Password must contain at least one digit.';
        }
        if (!/[!@#$%^&*]/.test(value)) {
            return 'Password must contain at least one special character.';
        }
        return '';
    };

    validateConfirmPassword = (password, confirmPassword) => {
        return password !== confirmPassword ? 'Passwords do not match.' : '';
    };

    handleInputChange = (field) => (event) => {
        const value = event.target.value;

        this.setState(
            {
                [field]: value,
            },
            () => {
                if (field === 'password') {
                    const passwordError = this.validatePassword(value);
                    this.setState((prevState) => ({
                        error: {
                            ...prevState.error,
                            password: passwordError,
                            confirmPassword: this.validateConfirmPassword(value, this.state.confirmPassword),
                        },
                    }));
                } else if (field === 'confirmPassword') {
                    this.setState((prevState) => ({
                        error: {
                            ...prevState.error,
                            confirmPassword: this.validateConfirmPassword(this.state.password, value),
                        },
                    }));
                }
            }
        );
    };

    reset = (event) => {
        event.preventDefault();
        const { password, disabled, error } = this.state;

        if (disabled || error.password || error.confirmPassword) {
            return;
        }

        const { history, addNotification, match } = this.props;
        const { params } = match;
        const { token } = params;

        this.setState({
            disabled: true,
        });

        reset(
            {
                password,
            },
            token
        )
            .then(() => {
                history.push('/login');
            })
            .catch(() => {
                this.setState({
                    disabled: false,
                });
                addNotification('somethingWentWrong', config.notificationLevels.error);
            });
    };

    render() {
        const { password, confirmPassword, error } = this.state;

        return (
            <div className="registration-content">
                <h1 style={{ color: '#043e5c' }} className="form-header">
                    Create a new password
                </h1>
                <div className="app-login-form">
                    <form onSubmit={this.reset}>
                        <div>
                            <p className={classNames('form-element-label', 'required', { error: error.password })}>
                                Password
                            </p>
                            <input
                                type="password"
                                className={classNames('form-element', { error: !!error.password })}
                                value={password}
                                onChange={this.handleInputChange('password')}
                            />
                            {error.password && <p style={{marginBottom: '20px', color: '#D01919'}} className="error-message">{error.password}</p>}
                        </div>
                        <div>
                            <p className="form-element-label required">Confirm Password</p>
                            <input
                                type="password"
                                className={classNames('form-element', { error: !!error.confirmPassword })}
                                value={confirmPassword}
                                onChange={this.handleInputChange('confirmPassword')}
                            />
                            {error.confirmPassword && (
                                <p style={{marginBottom: '20px', color: '#D01919'}} className="error-message">{error.confirmPassword}</p>
                            )}
                        </div>
                        <BlueButton styles={{marginBottom:'5px'}} type="submit" children="Save" />
                        <div style={{ textAlign: 'center' }}>
                            <Link to="/login" className="link">
                                <p className="link">Sign-In</p>
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

ResetPassword.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    addNotification: PropTypes.func.isRequired,
};

export default withRouter(ResetPassword);



// WEBPACK FOOTER //
// ./src/scenes/auth/ResetPassword.jsx